import types from './accessManagementActionsTypes';

export function accessManagementSetPartnersLoading(isLoading) {
    return { type: types.ACCESS_MANAGEMENT_SET_PARTNERS_LOADING, payload: isLoading };
}

export function accessManagementSetSelectedPartner(selectedPartner) {
    return { type: types.ACCESS_MANAGEMENT_SET_SELECTED_PARTNER, payload: selectedPartner };
}

export function accessManagementSetSearchPartner(searchPartner = "") {
    return { type: types.ACCESS_MANAGEMENT_SET_SEARCH_PARTNER, payload: searchPartner };
}

export function accessManagementSetShowPartners(showPartners) {
    return { type: types.ACCESS_MANAGEMENT_SET_SHOW_PARTNERS, payload: showPartners };
}

export function accessManagementSetShowUsers(showUsers) {
    return { type: types.ACCESS_MANAGEMENT_SET_SHOW_USERS, payload: showUsers };
}

export function accessManagementSetShowUser(showUser) {
    return { type: types.ACCESS_MANAGEMENT_SET_SHOW_USER, payload: showUser };
}

export function accessManagementSetSelectedUser(selectedUser) {
    return { type: types.ACCESS_MANAGEMENT_SET_SELECTED_USER, payload: selectedUser };
}

export function accessManagementSetEditApplication(editApplication) {
    return { type: types.ACCESS_MANAGEMENT_EDIT_APPLICATION, payload: editApplication };
}

export function accessManagementSetFilterApplication(application) {
    return { type: types.ACCESS_MANAGEMENT_SET_FILTER_APPLICATION, payload: application };
}

export function accessManagementSetFilterDepartment(department) {
    return { type: types.ACCESS_MANAGEMENT_SET_FILTER_DEPARTMENT, payload: department };
}

export function accessManagementSetShowUserModal(showUserModal) {
    return { type: types.ACCESS_MANAGEMENT_SET_SHOW_USER_MODAL, payload: showUserModal };
}

export function accessManagementSetModeUserModal(modeUserModal) {
    return { type: types.ACCESS_MANAGEMENT_SET_MODE_USER_MODAL, payload: modeUserModal };
}

export function accessManagementResetState() {
    return { type: types.ACCESS_MANAGEMENT_RESET_STATE };
}
